import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowUpIcon, MicIcon, SparklesIcon } from 'lucide-react';
import { quickPrompts } from '../../data/collectes';
import { CollecteDialog } from './CollecteDialog';
const PANEL_LAYOUT_ID = 'atna-collectes-panel';
export function AtnaAssistant() {
  const [value, setValue] = useState('');
  const [openedWith, setOpenedWith] = useState<string | null>(null);
  const open = (text: string) => {
    const trimmed = text.trim();
    if (!trimmed) return;
    setOpenedWith(trimmed);
    setValue('');
  };
  return <section aria-labelledby="atna-titre" data-id="element-664" data-mp="1m2bcac9pjn0m">
      <h2 id="atna-titre" className="sr-only" data-id="element-665" data-mp="1m3cx38giznvj">
        Assistant ATNA
      </h2>

      {openedWith !== null ? <div className="h-[66px]" aria-hidden="true" data-id="element-666" data-mp="1r0d53owxr0pa" /> : <motion.div layoutId={PANEL_LAYOUT_ID} style={{
      borderRadius: 999
    }} transition={{
      duration: 0.28,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-667" data-mp="3nugcsc59vsmy">
          <form onSubmit={event => {
        event.preventDefault();
        open(value);
      }} className="flex items-center gap-3 rounded-full border border-slate-200 bg-white py-2.5 pl-5 pr-2.5 shadow-lg shadow-ville-navy/5 transition-colors duration-150 ease-ville focus-within:border-ville-indigo" data-id="element-668" data-mp="3jzz57q4tg2t7">
            <SparklesIcon className="h-5 w-5 shrink-0 text-ville-indigo" aria-hidden="true" data-id="element-669" data-mp="3599ns60rhrgw" />
            <label htmlFor="atna-input" className="sr-only" data-id="element-670" data-mp="6sxmaz7ko68h">
              Demander à ATNA
            </label>
            <input id="atna-input" type="text" value={value} onChange={event => setValue(event.target.value)} placeholder="Demander à ATNA…" className="min-w-0 flex-1 border-0 bg-transparent py-2.5 text-base text-ville-navy placeholder:text-slate-400 focus:outline-none sm:text-lg" data-id="element-671" data-mp="1sjbj9el6i6r" />
            <button type="button" aria-label="Dicter votre question" className="grid h-10 w-10 shrink-0 place-items-center rounded-full text-slate-500 transition-colors duration-150 ease-ville hover:bg-ville-mist hover:text-ville-deep focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-blue" data-id="element-672" data-mp="2divfqqffj9d5">
              <MicIcon className="h-5 w-5" aria-hidden="true" data-id="element-673" data-mp="2a1g2qta35sig" />
            </button>
            <button type="submit" aria-label="Envoyer la question à ATNA" className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-ville-navy text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-blue focus-visible:ring-offset-2" data-id="element-674" data-mp="1wb474kealbmk">
              <ArrowUpIcon className="h-5 w-5" aria-hidden="true" data-id="element-675" data-mp="1dc8h7l9gvjej" />
            </button>
          </form>
        </motion.div>}

      <ul className="-mx-5 mt-4 flex snap-x gap-2.5 overflow-x-auto px-5 pb-1 sm:mx-0 sm:flex-wrap sm:overflow-visible sm:px-0" data-id="element-676" data-mp="1hcikur9sdxq8">
        {quickPrompts.map(prompt => <li key={prompt} className="shrink-0 snap-start" data-id="element-677" data-mp="tqgdu2az161r">
            <button type="button" onClick={() => open(prompt)} className={prompt === 'Bac non ramassé' ? 'rounded-full border border-ville-navy bg-ville-navy px-4 py-2 text-sm font-semibold text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2' : 'rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:bg-ville-indigo-soft hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo'} data-id="element-678" data-mp="ts1b3zoo733b">
              {prompt}
            </button>
          </li>)}
      </ul>

      <AnimatePresence data-id="element-679" data-mp="2fglq6ttck8vi">
        {openedWith !== null && <CollecteDialog key="atna-collectes-dialog" initialText={openedWith} layoutId={PANEL_LAYOUT_ID} onClose={() => setOpenedWith(null)} data-id="element-680" data-mp="2jj8kd1dhq5vv" />}
      </AnimatePresence>
    </section>;
}